import React, { useState } from "react";
import { theme } from "../../theme";
import { Button } from "../Button/Button";
import { Heading } from "../Heading/Heading";
import { Icon } from "../Icon/Icon";
import { Message } from "../Message/Message";
import { Panel, PanelProps } from "../Panel/Panel";
import { styles } from "./DefaultErrorComponent.styles";

export interface DefaultErrorComponentProps {
  children?: string;
  message?: string;
  basicMessage?: string;
  onRetry?: () => void;
  onClose?: () => void;
  styles?: PanelProps["styles"];
}
export const DefaultErrorComponent = ({
  children,
  basicMessage = "An error occured",
  message,
  styles: userStyles,
  onRetry,
  onClose,
}: DefaultErrorComponentProps): React.ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  return (
    <Panel
      data-testid="DefaultErrorBoundary"
      styles={[styles.panel, userStyles]}
    >
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          style={{
            position: "absolute",
            right: theme.spacing.small,
            top: theme.spacing.xsmall,
            background: "none",
            appearance: "none",
          }}
        >
          Close
        </button>
      )}
      <Heading styles={styles.heading} fontSize="xlarge" level={1}>
        {basicMessage}
      </Heading>
      <div style={styles.detailsContainer}>
        <div style={styles.toggleContainer}>
          <button
            css={styles.toggleContainerLeft}
            onClick={() => setIsOpen(!isOpen)}
          >
            <Icon.DoubleChevron
              size="small"
              styles={[
                {
                  transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                },
                styles.chevron,
              ]}
            />
            Details
          </button>
          {isOpen && (
            <div style={styles.clipboardWrapper}>
              {isCopied && (
                <Message type="success" small color="light">
                  Copied
                </Message>
              )}
              <Icon.Clipboard
                size="large"
                styles={styles.clipboard}
                onClick={() => {
                  navigator.clipboard.writeText(`${message}`);
                  setIsCopied(true);
                }}
              />
            </div>
          )}
        </div>
        {isOpen && (
          <Panel styles={styles.errorStack} shadow={false}>
            {message || children}
          </Panel>
        )}
      </div>
      {onRetry && (
        <Button
          styles={styles.buttonText}
          color="warning"
          size="small"
          onClick={() => {
            onRetry();
          }}
        >
          <Icon.Undo size="small" styles={styles.retryIcon} />
          Retry
        </Button>
      )}
    </Panel>
  );
};
